import { ButtonProps, IconButton, Theme } from '@mui/material';
import { DynamicDefaultProps } from '@synergy/utils';
import { PoolDynamicDefaultPropsComponent } from '@synergy/abstract';
import { WithStyles, createStyles, withStyles } from '@mui/styles';

const styles = (theme: Theme) =>
    createStyles({
        root: {
            backgroundColor: theme.palette.grey[200],
            width: 24,
            height: 24,
            '&:hover': {
                backgroundColor: theme.palette.grey[300],
            },
            '& > span > span': {
                fontSize: 20,
            },
        },
        disabled: {
            color: '#999999',
            '& svg': {
                color: '#999999',
            },
        },
        selected: {
            backgroundColor: theme.palette.primary.main,
            color: '#fff',
            '&:hover': {
                backgroundColor: theme.palette.primary.dark,
            },
        },
    });

interface PoolIconToggleButtonBaseProps extends WithStyles<typeof styles> {
    styleType?: keyof ReturnType<typeof styles>;
    selected?: boolean;
}

type PoolIconToggleButtonProps = PoolIconToggleButtonBaseProps & ButtonProps;

export const PoolIconToggleButton = withStyles(styles)(
    class PoolIconToggleButtonBase extends PoolDynamicDefaultPropsComponent<PoolIconToggleButtonProps> {
        protected override dynamicDefaultProps: DynamicDefaultProps<PoolIconToggleButtonProps> = {
            firstLevel: {
                color: 'primary',
                variant: 'contained',
            },
            secondLevel: {
                color: 'primary',
            },
            thirdLevel: {},
            link: {
                color: 'primary',
            },
        };

        private static getDisplayClass(props: PoolIconToggleButtonProps): string {
            if (props.selected) {
                return props.classes.selected;
            }

            if (props.styleType) {
                return props.classes[props.styleType];
            }

            return '';
        }

        private static getClassNames(props: PoolIconToggleButtonProps) {
            return `${this.getDisplayClass(props)} ${props.classes.root} ${props.className || ''}`;
        }

        public override render() {
            const { defaultProps } = this.state;
            const { styleType: _styleType, selected: _selected, classes, ...baseButtonProps } = this.props;
            const props = { ...defaultProps, ...this.props };

            return (
                <IconButton
                    {...defaultProps}
                    {...baseButtonProps}
                    classes={{ disabled: classes.disabled }}
                    className={PoolIconToggleButtonBase.getClassNames(props)}
                >
                    {props.children}
                </IconButton>
            );
        }
    }
);
